import React from 'react'
import { Link } from 'react-router-dom'

export default function NormalBlock(props){
  const {
    homepageBlock,
    url
  } = props

  if(homepageBlock.image) {
    return (
      <Link
        className="fa-stack fa-3x"
        to={ url }
        key={ homepageBlock.id }>
        <img
          src={ homepageBlock.image }
          alt='' />
      </Link>
    )
  } else if(props.onClick) {
    return (
      <span
        className="fa-stack fa-3x"
        key={ homepageBlock.id }>
        <div
          className="homepage-block" onClick={props.onClick}>
          { homepageBlock.title }
        </div>
      </span>
    )
  } else {
    return (
      <span
        className="fa-stack fa-3x"
        key={ homepageBlock.id }>
        <Link
          to={ url }>
          <div
            className="homepage-block">
            { homepageBlock.title }
          </div>
        </Link>
      </span>
    )
  }
}
